import QuickStartGuideHero from '@efdigital/ll-xceed-v2/components/coaching/coachee/quick-start-guide-hero';
import QuickStartGuideSections from '@efdigital/ll-xceed-v2/components/coaching/coachee/quick-start-guide-sections';
import QuickStartGuideSupportContacts from '@efdigital/ll-xceed-v2/components/coaching/coachee/quick-start-guide-support-contacts';
import {
  COACH_QUICK_START_GUIDE_SECTIONS,
  COACH_SUPPORT_ITEMS,
} from '@efdigital/ll-xceed-v2/data/coaching/coach/quick-start-guide';
import { PAGE_WRAPPER } from '@efdigital/ll-xceed-v2/utils/layout';
import { pageTitle } from 'ember-page-title';

<template>
  {{pageTitle "Help and support"}}
  <div class={{PAGE_WRAPPER}}>
    <div class="d-flex flex-column gap-4 gap-lg-5">
      <QuickStartGuideHero
        @title="Coach quick start guide"
        @intro="How coaching works on the platform, working with your coachees, and the tools for sessions, notes, and invoicing."
      />
      <QuickStartGuideSections @sections={{COACH_QUICK_START_GUIDE_SECTIONS}} />
      <QuickStartGuideSupportContacts @items={{COACH_SUPPORT_ITEMS}} />
    </div>
  </div>
</template>
